import { Page } from '@/core/architecture'

import { ConsoleTicketReceiveDetailTemplate } from './template'
import { useViewModel } from './viewModel'

/**
 * ConsoleTicketReceiveDetail Page
 * Implemented as a practical sample.
 */
export const ConsoleTicketReceiveDetail: Page = () => {
  const { state, actions } = useViewModel()

  return <ConsoleTicketReceiveDetailTemplate state={state} {...actions} />
}
